import React from 'react';
import {Grid,Paper,Stack,Typography} from '@mui/material';
import {BudgetValidationCards} from './budgetvalidation.models';

const money=(value:number)=>Number(value||0).toLocaleString();

type Props={cards:BudgetValidationCards};

export default class BudgetValidationCardsPanel extends React.PureComponent<Props>{
  render(){
    const c=this.props.cards;
    const items=[
      ['Requested',money(c.requestedamount)],
      ['Consolidated',money(c.consolidatedamount)],
      ['Arbitrated',money(c.arbitratedamount)],
      ['Approved Capacity',money(c.approvedcapacity)],
      ['Remaining Capacity',money(c.remainingcapacity)],
      ['Utilisation',`${Number(c.utilisationpercent||0).toFixed(1)}%`],
      ['Pending Arbitration',String(c.pendingarbitrations||0)],
      ['Blocking Issues',String(c.blockingissues||0)],
    ];
    return <Grid container spacing={1.5}>{items.map(([label,value])=><Grid size={{xs:6,sm:4,lg:3}} key={label}><Paper variant="outlined" sx={{p:1.5,height:'100%'}}><Stack><Typography variant="caption" color="text.secondary">{label}</Typography><Typography variant="h6">{value}</Typography></Stack></Paper></Grid>)}</Grid>;
  }
}
